module.exports = __webpack_public_path__ + "static/media/ganondorf_0.37331c49.png";